// extracted by mini-css-extract-plugin
export default {"active":"__profile_active__z48JT","tableResponsive":"__profile_tableResponsive__2G91G"};